module.exports = __webpack_public_path__ + "img/white-left-arrow.4a008106.svg";